export const en = {
    'banners-limit-in-campaign': 'You can add up to {limit} ads to a campaign.',
    error: 'Error occurred',
    'no-campaign-found': 'Campaigns not found',
    'search-by-campaign': 'Search by campaigns'
};
